export const WEBHOOK_DELIVER_JOB = 'webhook:deliver';
export const AUTOMATION_HUB_EVENT_TYPES = ['lead.created', 'reply.received', 'deal.won'];
export const WEBHOOK_EVENT_TYPES = [
    ...AUTOMATION_HUB_EVENT_TYPES,
    'automation.executed',
];
export const WEBHOOK_EVENT_LABELS = {
    'lead.created': 'Lead aangemaakt',
    'reply.received': 'Reply ontvangen',
    'deal.won': 'Deal gewonnen',
    'automation.executed': 'Automation uitgevoerd',
};
export const API_KEY_SCOPES = ['leads:read', 'leads:write', 'activities:write'];
//# sourceMappingURL=webhookJobs.js.map